import usePartner from './usePartner'

function useHasDisplayPromo (promoNames) {
  const qualifiedPromos = usePartner('promoService.promoNames') || []
  return promoNames && promoNames.some(dp => qualifiedPromos.includes(dp))
}

export default useHasDisplayPromo
